var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustpilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3171 25.6556L30.7116 36.1056L19.2216 27.7543L27.3171 25.6556ZM37.8151 14.2478H23.6096L19.2232 0.730469L14.8212 14.2509L0.615723 14.2323L12.1196 22.5975L7.71771 36.104L19.2216 27.7543L26.3252 22.5975L37.8151 14.2478Z",
    fill: "#29DA95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilot);
export default __webpack_public_path__ + "static/media/trustpilot.e6e7a3f5649e70d00f2eb1d23d6d9472.svg";
export { ForwardRef as ReactComponent };